import React, { FC, useEffect } from 'react';
import { Route, Switch, Redirect, HashRouter } from 'react-router-dom';
import i18next from 'i18next';
import { useDispatch } from 'react-redux';
import { LoginPageProps } from '~/pages/LoginPage/LoginPage';
import { ChangePasswordPageProps } from '~/pages/ChangePasswordPage/ChangePasswordPage';
import { ChangePasswordConfirmPageProps } from '~/pages/ChangePasswordConfirmPage/ChangePasswordConfirmPage';
import AxiosSetup from '~/components/AxiosSetup';
import { contentRequested } from './App.actions';
import CustomPageLoader from '../components/CustomPageLoader';
import MainLayout from '../layouts/MainLayout/MainLayout';
import FormLayout from '../layouts/FormLayout/FormLayout';
import MobileLayout from '../layouts/MobileLayout/MobileLayout';
import Constants from './Constants';

const LoginPage = (props: LoginPageProps) => <CustomPageLoader loader={() => import('../pages/LoginPage')} {...props} />;
const ChangePasswordPage = (props: ChangePasswordPageProps) => <CustomPageLoader loader={() => import('../pages/ChangePasswordPage')} {...props} />;
const ChangePasswordConfirmPage = (props: ChangePasswordConfirmPageProps) => <CustomPageLoader loader={() => import('../pages/ChangePasswordConfirmPage')} {...props} />;
const LogoffPage = () => <CustomPageLoader loader={() => import('../pages/LogoffPage')} />;
const RedirectLoginPage = () => <CustomPageLoader loader={() => import('../pages/RedirectLoginPage')} />;
const TechnicalErrorPage = () => <CustomPageLoader loader={() => import('../pages/TechnicalErrorPage')} />;
const LoggingTestPage = () => <CustomPageLoader loader={() => import('../pages/LoggingTestPage')} />;
const AccessErrorPage = () => <CustomPageLoader loader={() => import('~/pages/AccessErrorPage')} />;

const App: FC = () => {
  const dispatch = useDispatch();
  const lang = i18next.language;
  const isMobileIndicatorStored = (sessionStorage.getItem('mobileDeviceMode') === 'true');
  useEffect(() => {
    dispatch(contentRequested(lang));
  }, [dispatch, lang]);
  return (
    <MainLayout>
      <AxiosSetup />
      <Switch>
        <Route exact path="/mobile">
          <MobileLayout>
            <LoginPage mobileDeviceMode />
          </MobileLayout>
        </Route>
        <Route exact path="/">
          <HashRouter>
            <Switch>
              <Route exact path="/mobile/change-password">
                <MobileLayout>
                  <ChangePasswordPage mobileDeviceMode />
                </MobileLayout>
              </Route>
              <Route exact path={Constants.Pages.changePassword}>
                <FormLayout>
                  {isMobileIndicatorStored ?
                    <Redirect to={{ pathname: '/mobile/change-password' }} /> :
                    <ChangePasswordPage mobileDeviceMode={false} />}
                </FormLayout>
              </Route>
              <Route exact path="/mobile/change-password-confirm">
                <MobileLayout>
                  <ChangePasswordConfirmPage mobileDeviceMode />
                </MobileLayout>
              </Route>
              <Route exact path={Constants.Pages.changePasswordConfirm}>
                <FormLayout>
                  {isMobileIndicatorStored ?
                    <Redirect to={{ pathname: '/mobile/change-password-confirm' }} /> :
                    <ChangePasswordConfirmPage mobileDeviceMode={false} />}
                </FormLayout>
              </Route>
              <Route exact path={Constants.Pages.logOff}>
                <LogoffPage />
              </Route>
              <Route exact path={Constants.Pages.loggingTest}>
                <FormLayout>
                  <LoggingTestPage />
                </FormLayout>
              </Route>
              <Route exact path={Constants.Pages.accessError}>
                <FormLayout>
                  <AccessErrorPage />
                </FormLayout>
              </Route>
              <Route exact path={Constants.Pages.redirectLogin}>
                <FormLayout>
                  <RedirectLoginPage />
                </FormLayout>
              </Route>
              <Route exact path={Constants.Pages.technicalError}>
                <FormLayout>
                  <TechnicalErrorPage />
                </FormLayout>
              </Route>
              <Route exact path={Constants.Pages.catchAll}>
                <FormLayout>
                  {/* eslint-disable-next-line no-nested-ternary */}
                  {isMobileIndicatorStored ? <Redirect to={{ pathname: '/mobile' }} /> : <LoginPage mobileDeviceMode={false} />}
                </FormLayout>
              </Route>
            </Switch>
          </HashRouter>
        </Route>
      </Switch>
    </MainLayout>
  );
};

export default App;
